import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import {List, ListItem} from 'material-ui/List'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import Divider from 'material-ui/Divider'

import { objectComments } from 'selectors/comments'
import { currentUser } from 'selectors/common'
import { properties } from 'selectors/entities'
import { currentUserNotifications, currentUserOpenNotifications } from 'selectors/notifications'

import EventList from './events/List'
import EventCard from './events/Card'

import commentWizard from 'actions/commentWizard'
import tableActions from 'actions/table'
import commentActions from 'actions/commentActions'
import { propertiesLLEx } from 'selectors/properties'
import CommentForm from './CommentForm'


let select = (state, props) => ({
	mode: state.commentBuffer.mode
  , comments: objectComments(state, props)
  , currentUserOpenNotifications: currentUserOpenNotifications(state)
	, properties: properties(state)

	, events: propertiesLLEx(state)
	, currentUser: currentUser(state)
})

export class Comments extends Component {
	state = {
    value1: this.props.propertyID && this.props.propertyID!="all" && this.props.propertyID || null
	, value2: null
  };
	handleChange = (event, index, value1) => {this.setState({value1});if (value1=="0")this.setState({value2:null})}
	handleChange2 = (event, index, value2) => this.setState({value2});
	render(){
		let { props } = this
		let index=0;
		let events = R.filter(event=>event.type!="Divider")((props.events[this.state.value1] || {}).history || [])
		events = R.map(x=>{index++;return{...x, _id:index}})(events)
		return(
				<div
					style={{margin:"15px 15px 0px 15px", overflow:"hidden", position: "relative"}}

				>
					<div>
						{/*<div style={{
							float: "left"
							, width: "26px"
							, height: "15px"
							, position: "relative"
							, top: "25px"
							, left: "-3px"
							, color: "orange"
						}}>
							{!this.state.value1 && <i
								className="material-icons"
								style={{
									width: "26px"
								  , color: "orange"
								}}
							>
								arrow_forward
							</i>}
						</div>*/}
						<SelectField
								value={this.state.value1}
								hintText="Select property"
		          				onChange={this.handleChange}
								disabled = {!!this.props.propertyID && this.props.propertyID!="all"}
								style={{color: "black", position: "relative", width: "100%", top: "-10px"}}

								labelStyle={{color: "black", fontWeight: "bold"}}
								hintStyle = {{fontSize: "14px", fontWeight: "bold"}}
								underlineStyle = {this.state.value1 ? {}:{border: "1px solid #009688"}}
								underlineDisabledStyle={{border: "1px solid rgb(230,230,230)"}}
			        		>
								{R.map((property, index)=>(
									<MenuItem value={property._id} primaryText={property.alias} />
								), R.values(props.properties))}
								<Divider />
								<MenuItem value={'0'} style={{width:"100%"}} primaryText={'Not related to any property'} />
			        	</SelectField>
					</div>

					<div>
						{/*<div style={{
							float: "left"
							, width: "26px"
							, height: "15px"
							, position: "relative"
							, top: "15px"
							, left: "-3px"
							, color: "orange"
						}}>
							{this.state.value1 && this.state.value1!=="0" && !this.state.value2 && <i
								className="material-icons"
								style={{
									width: "26px"
								  , color: "orange"
								}}
							>
								arrow_forward
							</i>}
						</div>*/}
						{this.state.value1 && this.state.value1!=="0" && <SelectField
							hintText="Select activity"
							value={this.state.value2}
							onChange={this.handleChange2}
							style={{color: "black", position: "relative", width: "100%", top: "-10px"}}

							labelStyle={{color: "black", fontWeight: "bold"}}
							hintStyle = {{fontSize: "14px", fontWeight: "bold"}}
							underlineStyle = {this.state.value2 ? {}:{border: "1px solid #009688"}}
							underlineDisabledStyle={{border: "1px solid rgb(230,230,230)"}}
						>
							{events && R.map(event =>
									<MenuItem value={event._id} primaryText={<EventCard event={event} currentDate={props.currentDate} />} />
								, events || [])}
								<Divider />
							<MenuItem value={"0"} style={{width:"100%"}} primaryText={<span style={{fontSize: "16px", color: "black", marginLeft:"3px"}}>Other</span>} />
						</SelectField>}
					</div>


					{ (this.state.value2 && this.state.value2!=="0") && <CommentForm objectID={events[this.state.value2-1].url.split('/')[events[this.state.value2-1].url.split('/').length-1]} path={props.path} />}
					{ (this.state.value2 && this.state.value2=="0" && this.state.value1) && <CommentForm objectID={this.state.value1} path={props.path} />}
					{ (this.state.value1=="0") && <CommentForm objectID={props.currentUser} path={props.path} />}
				</div>
		)
	}
}

export default connect(select, R.mergeAll([commentWizard, tableActions, commentActions]))(Comments)



// WEBPACK FOOTER //
// ./src/components/Communication/wizardComment.js